/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactElement, useState, useCallback, useMemo, useEffect } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  InputSearch,
  Button,
  Pagination,
  Table,
  GoBackButton,
} from '~/components';
import { ExLibraryModal } from '~/components/ExLibraryModal';
import { ISearch } from '~/components/Pagination/Search';
import { useLoading } from '~/hooks/loading';
import { IPagination, PageOptionsRequest } from '~/models/Common';
import { IExercise } from '~/models/Exercise';
import { ExerciseService } from '~/services';
import { orderTrainingsByName } from '~/utils/orderFunction';

import * as S from './styles';

interface IExercisesListRouteState {
  segmentName: string;
}

function ExercisesList(): ReactElement {
  const { setLoading } = useLoading();

  const { segmentName } = useParams<IExercisesListRouteState>();

  const [exercises, setExercises] = useState<IPagination<IExercise[]>>({
    data: [],
    lastPage: 0,
    page: 1,
    perPage: 1,
    total: '0',
  });
  const [pageOptions, setPageOptions] = useState<PageOptionsRequest>({
    page: 1,
  });
  const [searchFilter, setSearchFilter] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [removeButtonFocused, setRemoveButtonFocused] = useState(false);
  const router = useHistory();

  if (!segmentName) {
    toast.error('Segmento muscular inválido.');
    router.goBack();
  }

  const handleGetExercises = useCallback(
    async (data: ISearch) => {
      try {
        setLoading(true);
        // console.log('data:', data);

        const response = await ExerciseService.getAllExercises(
          segmentName,
          data,
        );

        response.data[0].exercicies.data?.sort(orderTrainingsByName);

        setExercises(response.data[0].exercicies);

        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error('Ocorreu um problema ao carregar os dados!');
      }
    },
    [segmentName],
  );

  const handleNavigateToEditExercise = (exerciseId: string) => {
    if (!removeButtonFocused) {
      router.push(`/ilab/exercises/edit/${exerciseId}`);
    }
  };

  // const handleDeleteExercise = async () => {
  //   try {
  //     const result = await ExerciseService.deleteExercise(
  //       selectedExercise?.id!,
  //     );
  //     if (result.status === 200) {
  //       toast.success('Exercicio deletado com sucesso!');
  //       router.goBack();
  //     } else {
  //       toast.error('Ocorreu um problema ao deletar o exercicio!');
  //     }
  //   } catch (error) {
  //     toast.error('Ocorreu um problema ao deletar o exercicio!');
  //   }
  // };

  // const handleNavitageToExerciseCadaster = useCallback(() => {
  //   router.push(`/ilab/exercises/cadaster/${segmentName}`);
  // }, [router, segmentName]);

  useEffect(() => {
    handleGetExercises({
      searchFilter,
      page: pageOptions.page,
      perpage: 9999999,
    });
  }, [handleGetExercises, pageOptions.page, searchFilter, modalIsOpen]);

  const ExercisesTableMemo = useMemo(
    () => (
      <Table noItems={exercises?.data?.length === 0} colsNames={['Nome', '']}>
        {exercises?.data?.map((exercise) => (
          <tr
            key={exercise.id}
            onClick={() => handleNavigateToEditExercise(exercise.id)}
          >
            <td style={{ width: '90%' }}>{exercise.name}</td>
            {/* <td>
              <S.DeleteButton
                onMouseEnter={() => setRemoveButtonFocused(true)}
                onMouseLeave={() => setRemoveButtonFocused(false)}
                onClick={() => {
                  setConfirmDeleteModal(true);
                  setSelectedExercise({ name: exercise.name, id: exercise.id });
                }}
              >
                <FaTrash /> Excluir
              </S.DeleteButton>
            </td> */}
            <td>{'>'}</td>
          </tr>
        ))}
      </Table>
    ),
    [exercises, handleNavigateToEditExercise],
  );

  console.log('exercises:', exercises);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Listagem de Exercícios - {segmentName}</S.Title>
          <InputSearch
            name="exercise-search"
            placeholder="Buscar por nome"
            onSearch={(value) => setSearchFilter(value)}
          />
        </S.Header>
        {ExercisesTableMemo}
        <S.Footer>
          <Button
            textContent="Criar"
            onClick={() => setModalIsOpen(true)}
            size="small"
            variant="yellow"
            extraStyles={{
              maxWidth: 300,
            }}
          />
          {/* <Pagination
            pageCount={exercises.lastPage!}
            pageRangeDisplayed={pageOptions.page}
            {...{ setPageOptions }}
          /> */}
        </S.Footer>
      </S.Container>
      <ExLibraryModal
        isRegisteringExercise
        modalVisible={modalIsOpen}
        categoryName={segmentName}
        setModalVisible={setModalIsOpen}
        title="CADASTRAR NOVO EXERCÍCIO"
        modalType="addCategoryExercise"
      />
    </>
  );
}

export default ExercisesList;
